'use strict'

class TransferItem
  @convertIdToNumber = (id) ->
    num = 0
    for ch, index in id
      num = num * 26 + id.charCodeAt(index) - 97
    num

  constructor: (@id, @name) ->

  getKey: ->
    result = ''
    num = @id
    loop
      result = String.fromCharCode(97 + (num % 26)) + result
      num = ~~(num / 26)
      break if num is 0
    result

  getCompletePath: ->
    # Recreate the complete path based on the folder tree
    item = this
    parts = []
    parts.push item.name if item.name
    parts.unshift item.name while (item = item.folder)?.folder # TODO: Make this a bit more readable
    parts.join '/'

export default TransferItem
